import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../lib/useAuth'
import AuthLayout, { Field, SubmitButton, Notice } from '../components/AuthLayout'

/**
 * /reset-password — the destination of the emailed reset link. Supabase's
 * detectSessionInUrl consumes the recovery token and fires PASSWORD_RECOVERY;
 * the hook flips `recoveryReady` once that session exists. Submitting calls
 * updateUser({ password }); on success the hook routes to /signin.
 */
export default function ResetPassword() {
  const auth = useAuth({ mode: 'reset' })
  const [password, setPassword] = useState('')

  return (
    <AuthLayout
      gauge
      title="Set a new password"
      subtitle="Choose a new password for your account."
    >
      <Notice notice={auth.notice} />

      {auth.configured && !auth.recoveryReady && (
        <p className="rrauth__notice rrauth__notice--info">
          Open this page from the password-reset link in your email to continue.
        </p>
      )}

      <form onSubmit={(e) => { e.preventDefault(); auth.updatePassword({ password }) }}>
        <Field
          label="New password" name="password" type="password" value={password} onChange={setPassword}
          placeholder="At least 8 characters" autoComplete="new-password" required minLength={8}
          autoFocus disabled={!auth.configured}
        />
        <SubmitButton busy={auth.busy} disabled={!auth.configured} busyLabel="Updating…">Update password</SubmitButton>
      </form>

      {!auth.configured && (
        <p className="rrauth__notice rrauth__notice--info" style={{ marginTop: 16 }}>
          Password reset isn’t configured in this build.
        </p>
      )}

      <p className="rrauth__back">
        <Link className="rrauth__link" to="/signin">← Back to sign in</Link>
      </p>
    </AuthLayout>
  )
}
